import { Box, TextField, Typography } from '@mui/material'
import React from 'react'
import { averageStyle, newBtnStyle, typoStyle } from "../styles/globalStyle"
import IzostatikPresModal from '../components/modals/IzostatikPresModal';
import useArge from '../hooks/useArge';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import { useState } from 'react';
import DeleteModals from '../components/deleteModals/DeleteModals';
import IzoStatikPres_DataTable from '../components/tables/IzoStatikPres_DataTable';
import { HiOutlineSearch } from "react-icons/hi";
import { toastWarnNotify } from '../helpers/ToastNotify';
import HammaddeHazirlamaModal from '../components/modals/HammaddeHazirlamaModal';
import HammaddeHazirlama_DataTable from '../components/tables/HammaddeHazirlama_DataTable';



const HammaddeHazirlama = () => {

    let getVardiya = 0;
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const { getFireData, getMaterialCenter, getWorkCenter } = useArge()
    const { currentUser } = useSelector((state) => state.auth)
    const { workCenterCode, materialCode, hammaddeHazirlama, izoStatikPresData, loading,machineLoading,materialLoading } = useSelector((state) => state.arge)

    const [averages, setAverages] = useState({
        viskozite_t1: 0,
        viskozite_t2: 0,
        mikserSicaklik: 0,
        tiksotropi_t1t2: 0,
        mikserYogunluk: 0,
    });

    const [infoDate, setInfoDate] = useState({
        dateFrom: "",
        dateTo: ""
    })

    const getShift = () => {
        //! padStart(2,'0') metodu ile hedefUzunluk ve eklenecek karakterler olarak iki parametre alır.
        const hour = new Date().getHours().toString().padStart(2, '0')

        if (hour > 8 && hour < 16) {
            getVardiya = 2
        }
        else if (hour > 16 && hour < 23) {
            getVardiya = 3
        }
        else {
            getVardiya = 1
        }

        return getVardiya

    }

    const [info, setInfo] = useState({
        department: "Hammadde",
        type: "HammaddeHazirlama",
        is_merkezi: "",
        urun_kodu: "",
        uygunsuzluktipi: "",
        aciklama: "",
        vardiyasorumlusu: "",
        oldData_date: "",
        granulNemOrani: "",
        besyuzMikron: "",
        dortyuzMikron: "",
        ucyuzonbesMikron: "",
        ikiyuzMikron: "",
        yuzMikron: "",
        lessthanyuzMikron: "",
        granulAkisi: "",
        granulYogunluk: "",
        mikserSicaklik: "",
        mikserYogunluk: "",
        viskozite_t1: "",
        viskozite_t2: "",
        tiksotropi_t1t2: "",
        sirlamaTankiSicaklik:"",
        sirlamaTankiYogunluk:"",
        viskozite_g1: "",
        viskozite_g2: "",
        tiksotropi_g1g2: "",
        ph:"",
        vardiya: getShift(),
        date: "",
        time: "",
        kontroleden_kisi: currentUser,
        newMaterialName: ""
    })

    const [open, setOpen] = useState(false)
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false)
        setInfo({
            type: "HammaddeHazirlama",
            is_merkezi: "",
            urun_kodu: "",
            uygunsuzluktipi: "",
            aciklama: "",
            vardiyasorumlusu: "",
            oldData_date: "",
            granulNemOrani: "",
            besyuzMikron: "",
            dortyuzMikron: "",
            ucyuzonbesMikron: "",
            ikiyuzMikron: "",
            yuzMikron: "",
            lessthanyuzMikron: "",
            granulAkisi: "",
            granulYogunluk: "",
            mikserSicaklik: "",
            mikserYogunluk: "",
            viskozite_t1: "",
            viskozite_t2: "",
            tiksotropi_t1t2: "",
            vardiya: getShift(),
            date: "",
            time: "",
            kontroleden_kisi: currentUser,
            newMaterialName: ""
        })
    }

    const [delOpen, setdelOpen] = React.useState(false);
    const delHandleOpen = () => setdelOpen(true);
    const delHandleClose = () => setdelOpen(false);


    useEffect(() => {
        getMaterialCenter() //makine isimlerini çek
        getWorkCenter() //ürün kodlarını çek

        getFireData("HammaddeHazirlama") //firebase den verileri getir
    }, [])


    // istatistik datasındaki ortalama hesaplamasını yapar
    useEffect(() => {
        const dizi = Object.keys(hammaddeHazirlama).map(key => { return { id: key, ...hammaddeHazirlama[key] } })
        dizi.sort((a, b) => {
            const convertDateTime = (date, time) => {
                if (!date || !time) {
                    return new Date(0); // 1 Ocak 1970
                }
                const [day, month, year] = date.split('-').map(num => num.padStart(2, '0'));
                const [hours, minutes] = time.split(':').map(num => num.padStart(2, '0'));
                return new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
            };

            const dateTimeA = convertDateTime(a.date, a.time);
            const dateTimeB = convertDateTime(b.date, b.time);

            return dateTimeB - dateTimeA;
        });

        // Ortalama hesaplamaları
        const total = {
            viskozite_t1: 0,
            viskozite_t2: 0,
            mikserSicaklik: 0,
            tiksotropi_t1t2: 0,
            mikserYogunluk: 0,
        };
        const count = dizi.length;

        dizi.forEach(item => {
            total.viskozite_t1 += parseFloat(item.viskozite_t1) || 0;
            total.viskozite_t2 += parseFloat(item.viskozite_t2) || 0;
            total.mikserSicaklik += parseFloat(item.mikserSicaklik) || 0;
            total.tiksotropi_t1t2 += parseFloat(item.tiksotropi_t1t2) || 0;
            total.mikserYogunluk += parseFloat(item.mikserYogunluk) || 0;
        });

        const averages = {
            viskozite_t1: (total.viskozite_t1 / count).toFixed(2),
            viskozite_t2: (total.viskozite_t2 / count).toFixed(2),
            mikserSicaklik: (total.mikserSicaklik / count).toFixed(2),
            tiksotropi_t1t2: (total.tiksotropi_t1t2 / count).toFixed(2),
            mikserYogunluk: (total.mikserYogunluk / count).toFixed(2),
        };

        // setpresData(dizi);
        setAverages(averages); // Ortalamaları state'e kaydediyoruz
    }, [hammaddeHazirlama]);


    const handleChangeDate = (e) => {
        const { name, value } = e.target
        setInfoDate({ ...infoDate, [name]: value })
    }

    const handleDateFilter = () => {

        if (infoDate.dateFrom && infoDate.dateTo) {

            //! tarih filtreleme işleminde son seçilen sarih bilgisi localStorage taragında saklanır.
            // localStorage.setItem('lastSelectedDate', JSON.stringify(info))

            getFireData('HammaddeHazirlama', infoDate.dateFrom, infoDate.dateTo)

        }
        else {
            toastWarnNotify('Tarih bilgisini kontrol ediniz !')
        }

    }

    // console.log("info : ", info)

    return (

        <div>
            <Typography mt={8} align='center' variant='h5' fontWeight={700} sx={typoStyle}>
                Hammadde Hazirlama
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                <Box>
                    <Button onClick={handleOpen} variant='outlined' sx={newBtnStyle}>New</Button>
                </Box>


                <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 1, alignItems: 'center', p: 2 }}>
                    <Typography>From</Typography>
                    <TextField
                        size='small'
                        required
                        id='dateFrom'
                        name='dateFrom'
                        type='date'
                        value={infoDate.dateFrom}
                        onChange={handleChangeDate}
                    />

                    <Typography>To</Typography>
                    <TextField
                        size='small'
                        required
                        id='dateTo'
                        name='dateTo'
                        type='date'
                        value={infoDate.dateTo}
                        onChange={handleChangeDate}
                    />
                    <HiOutlineSearch size={30} color='black' onClick={handleDateFilter} cursor={'pointer'} style={{ marginLeft: 15 }} />
                </Box>

            </Box>


            <HammaddeHazirlamaModal
                open={open}
                handleClose={handleClose}
                info={info}
                setInfo={setInfo}
                workCenterCode={workCenterCode}
                materialCode={materialCode}
                machineLoading={machineLoading}
                materialLoading={materialLoading}
            />

            <DeleteModals
                delOpen={delOpen}
                delHandleClose={delHandleClose}
                delHandleOpen={delHandleOpen}
                setdelOpen={setdelOpen}
                info={info}
            />




            <Box>
                {
                    loading ?
                        (
                            <Typography>Loading..</Typography>
                        )
                        :
                        (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>

                                    <Typography style={averageStyle}>viskozite_t1 : {averages.viskozite_t1}</Typography>
                                    <Typography style={averageStyle}>viskozite_t2 : {averages.viskozite_t2}</Typography>
                                    <Typography style={averageStyle}>mikserYogunluk : {averages.mikserYogunluk}</Typography>
                                    <Typography style={averageStyle}>mikserSicaklik : {averages.mikserSicaklik}</Typography>
                                    <Typography style={averageStyle}>tiksotropi_t1t2 : {averages.tiksotropi_t1t2}</Typography>

                                </Box>

                                <HammaddeHazirlama_DataTable handleOpen={handleOpen} delHandleOpen={delHandleOpen} setInfo={setInfo} info={info} hammaddeHazirlama={hammaddeHazirlama} setFilterModel={setFilterModel} filterModel={filterModel} />
                            </Box>
                        )
                }
            </Box>



        </div>

    )
}

export default HammaddeHazirlama